import { Card, Input, Table } from 'antd';
import numeral from 'numeral';
import pluralize from 'pluralize';
import React from 'react';

import { CsvExportButton } from '../../../../components/CsvExport/CsvExportButton';
import type { VirtualDirectoryUserFragment } from '../../../../graphql/api/generated';
import { normalizeColumns } from '../../../helpers/normalizeColumns';

import { createUnlistedReasonsColumn, residentColumns } from './columns';
import { useVirtualDirectoryResidentFilters } from './hooks/useVirtualDirectoryResidentFilters';

interface IVirtualDirectoryResidentsProps {
  residents: VirtualDirectoryUserFragment[];
  unlistedReasonFilters: string[];
  csvExportTitle: string;
  loading: boolean;
}

export const VirtualDirectoryResidents: React.FC<IVirtualDirectoryResidentsProps> = (props) => {
  const { residents: allResidents, unlistedReasonFilters, csvExportTitle, loading } = props;

  const {
    setFilters,
    onSearch,
    filteredResidents,
  } = useVirtualDirectoryResidentFilters(allResidents);

  const columns = [...residentColumns, createUnlistedReasonsColumn(unlistedReasonFilters)];
  const normalizedColumns = normalizeColumns(columns);

  const displayedTotal = (
    `${numeral(filteredResidents.length).format('1,000')} ` +
    `${pluralize('resident', filteredResidents.length)}`
  );

  return (
    <Card
      title={displayedTotal}
      bordered={false}
      bodyStyle={{ margin: 0, padding: 0 }}
      headStyle={{ margin: 0, padding: 0, borderBottom: 'none' }}
      extra={(
        <div style={{ display: 'flex' }}>
          <CsvExportButton
            title={csvExportTitle}
            rows={filteredResidents}
            columns={columns}
            disabled={loading}
            buttonStyle={{ marginRight: 8 }}
          />
          <Input.Search
            enterButton
            allowClear
            placeholder='Search by resident name or unit number'
            onChange={e => onSearch(e.target.value)}
            onSearch={value => onSearch(value)}
            style={{ minWidth: 350 }}
          />
        </div>
      )}
    >
      <Table
        loading={{ size: 'large', spinning: loading }}
        rowKey={u => `${u.userId}:${u.unitId}`}
        dataSource={filteredResidents}
        scroll={{ x: true }}
        columns={normalizedColumns}
        showSorterTooltip={false}
        pagination={false}
        style={{ clear: 'both', marginTop: 20 }}
        onChange={(pagination, nextFilters) => setFilters(nextFilters)}
      />
    </Card>
  );
};
